import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-paper border-t border-ink/10 px-6 md:px-10 py-10" data-id="element-43">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-44">
        <p className="brandmark" data-id="element-45">Courage Collective</p>
        <div className="flex items-center gap-5 text-ink/70" data-id="element-46">
          <a href="#" aria-label="Instagram" className="hover:text-ink transition-colors" data-id="element-47">
            <InstagramIcon size={16} strokeWidth={1.4} data-id="element-48" />
          </a>
          <a href="#" aria-label="Email" className="hover:text-ink transition-colors" data-id="element-49">
            <MailIcon size={16} strokeWidth={1.4} data-id="element-50" />
          </a>
        </div>
      </div>
    </footer>;
}